import { ReactNode, useMemo } from "react";
import { PricingScope, PricingScopeContext } from "./pricingScope";

interface Props {
    scope: PricingScope;
    children: ReactNode;
}

export const PricingScopeProvider = ({ scope, children }: Props) => {
    const value = useMemo(
        () => ({ storeId: scope.storeId, storeName: scope.storeName }),
        [scope.storeId, scope.storeName]
    );

    return (
        <PricingScopeContext.Provider value={value}>
            {children}
        </PricingScopeContext.Provider>
    );
};
